export default __webpack_public_path__ + "static/media/ellipse30Map4.031b379f.svg";